export default "__VITE_ASSET__BQWo1gk5__"